import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { AttractionForm } from './../forms'
import { Dashboard } from './../layouts'

const styles = theme => ({
    //
})

class AttractionNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Attractions'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <AttractionForm
                    path="attractions"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(AttractionNew)
